export const getMatrixB = (state) => state?.matrix?.matrixB || {};
